module.exports = __webpack_public_path__ + "static/img/render3-thumb.1c0e96f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/render3-thumb.jpg
// module id = Mc47
// module chunks = 0